// eslint-disable-next-line jst-gyl/check-keywords
import {
    UserWithLabelsVo,
    EditCompanyLabelParam,
    GetSearchItemUsingGetParams,
    UnBindingParam,
    GrantAuthParam,
    ResendSmsAuthCodeParam,
} from '@servicesTypings/companyRequest'
import {
    SimpleInfoUsingGetParams,
    SimpleCompanyInfo,
    QuerySupplierContactWayUsingGetParams,
    ContactWayQueryVo,
    InfoUsingGet1Params,
    InfoQueryByOpUsingGetParams,
    InfoQueryByOpUsingGet1Params,
    QueryContactPhoneUsingGetParams,
    ChannelContactParam,
    DirectorInfoParam,
    DirectorInfoVo,
} from '@servicesTypings/drpRequest'
import { companyRequest, securityRequest, timeOutTimer, drpRequest, towerAftersaleRequest } from '@/utils/request'
import { getAfterLoginFromSource } from '@/modules/user/features/afterLoginFromSource'
import { isSingleAppDomain } from '@/utils/singleApp'

const CHANNEL_USER_PATH = '/buyer/user/info'
const SUPPLIER_USER_PATH = '/user/supplier/getUserInfo'
const ADMIN_USER_PATH = '/op/user/getUserInfo'

const checkPhoneIsPresent = '/myPartner/checkPhoneIsPresent'

// 由于 contractVersion 用户信息接口给的系统版本给的字段 contractVersion 为汉字，杭州那边资源位等接口需要的是 1、2、3、4、5
// 注意：contractVersion 为空也表示免费版，在用户信息中多加个 appVersion 存储转化后的值

// 对应关系如下：
const VERSITION_MAP = {
    免费版: '1',
    纵横版: '5',
    纵横标准版: '6',
    专业版: '2',
    高阶版: '3',
    企业版: '4',
}

const ROLE_MAP = {
    true: '1',
    false: '2',
}

// isPrimaryAccount 后续可能废弃 @桑榆
const transUserInfo = res => {
    const { data } = res

    if (window.MASTER_IS_SUPPLIER) {
        return {
            ...res,
            data: {
                coId: data?.coId,
                coName: data?.coName, // ERP名称
                supplierId: data?.id,
                userName: data?.coCompanyUser.userName,
                headPic: data?.coCompanyUser.headPic,
                supplierName: data?.supplierName,
                supplierLogo: data?.supplierLogo,
                loginName: data?.coCompanyUser.loginName,
                phone: data?.coCompanyUser.phone,
                uid: data?.coCompanyUser.uid,
                isPrimaryAccount: data?.isAdmin,
                isAdmin: data?.isAdmin, // 管理员
                isAgent: data?.isAgent, // 是否代理登录
                // isAgent: true,
                currentUserName: data?.currentUserName, // 代理登录的中台用户名
                isSteward: data?.isSteward, // 维护员
                contractVersion: data?.contractVersion,
                appRole: ROLE_MAP[data?.isAdmin],
                appVersion: VERSITION_MAP[data?.contractVersion] || '1', // 默认为免费版
                hasCoChannel: data?.hasCoChannel, // 是否已经初始化分销商身份
                tagNames: data?.tagNames,
                checkInTime: data?.checkInTime,
                userCreated: data?.coCompanyUser?.created,
                kaCustomer: data.kaCustomer, // 是否ka用户
                dockingPeopleName: data?.dockingPeople?.fullName, // 负责运营名称
                dockingHeadPicture: data?.dockingPeople?.headPicture, // 负责运营头像
                dockingQrCode: data?.dockingPeople?.qrCode, // 负责运营二维码
                secondaryDistribution: data?.secondaryDistribution, // 是否二级分销
            },
        }
    }

    return {
        ...res,
        data: {
            ...(data || {}),
            uid: data?.uid,
            isPrimaryAccount: data?.isAdmin,
            isAdmin: data?.isAdmin,
            isAgent: data?.isAgent, // 是否代理登录
            // isAgent: true,
            currentUserName: data?.currentUserName, // 代理登录的中台用户名
            isSteward: data?.isSteward,
            contractVersion: data?.contractVersion,
            appRole: ROLE_MAP[data?.isAdmin],
            appVersion: VERSITION_MAP[data?.contractVersion] || '1', // 默认为免费版
            userCreated: data?.userCreated,
            kaCustomer: data.kaCustomer, // 是否ka用户
            dockingPeopleName: data?.dockingPeople?.fullName, // 负责运营名称
            dockingHeadPicture: data?.dockingPeople?.headPicture, // 负责运营头像
            dockingQrCode: data?.dockingPeople?.qrCode, // 负责运营二维码
        },
    }
}

const getUserInfoPathAndTerminalName = () => {
    // 为了解决shopAuth 业务要求 isSingleAppDomain 平台就只有供应侧
    if (window.MASTER_IS_SUPPLIER || (PROJECT_CONFIG.terminalName === 'ACCOUNT' && isSingleAppDomain)) {
        return {
            userInfoPath: `${SUPPLIER_USER_PATH}?supplierType=shop`,
            terminalName: window.PROJECT_CONFIG.supplierTerminalName,
        }
    }
    if (PROJECT_CONFIG.terminalName === 'OP') {
        return {
            userInfoPath: ADMIN_USER_PATH,
            terminalName: window.PROJECT_CONFIG.terminalName,
        }
    }

    // 默认渠道侧
    return {
        userInfoPath: CHANNEL_USER_PATH,
        terminalName: window.PROJECT_CONFIG.channelTerminalName,
    }
}

export async function getUserInfo(param = {}) {
    let temp = {
        ...param,
    }
    if (PROJECT_CONFIG.terminalName === 'OP') {
        return securityRequest.get('/security/user/info', { params: temp, timeout: timeOutTimer }).then(res => {
            return transUserInfo(res)
        })
    }

    const fromSource = await getAfterLoginFromSource()
    // afterLogin 已经把后端确认过的 fromSource 落本地了，这里固定以本地缓存为准回传给 getUserInfo。
    if (fromSource) {
        temp.fromSource = fromSource
    }
    const { userInfoPath, terminalName } = getUserInfoPathAndTerminalName()
    temp.terminalName = terminalName
    return drpRequest.get(userInfoPath, { params: temp, timeout: timeOutTimer }).then(res => {
        return transUserInfo(res)
    })
}

// tab切换的时候调用用户信息
/**
 * getLoginName
 */
export function getFastUserInfo(): API.Res<string> {
    return drpRequest.get('/user/getLoginName')
}

export function getDirectInfo() {
    let directorInfoPath = '/channel/load'
    if (window.MASTER_IS_SUPPLIER) {
        directorInfoPath = '/supplierInfo/load'
    }
    return drpRequest.get(directorInfoPath).then(res => {
        const { data } = res
        return {
            ...res,
            data: {
                weiXinNum: data.weiXinNum,
                phone: data.phone,
                contactName: data.contactName,
                id: data.id,
            },
        }
    })
}

export function getIsHasPhone(companyType) {
    return drpRequest.get(checkPhoneIsPresent, { params: { companyType } })
}

export function updatePassword(data) {
    let updatePwPath = '/user/changePassword'

    if (PROJECT_CONFIG.terminalName === 'OP') {
        updatePwPath = '/op/user/changePassword'
    }

    return companyRequest.post(updatePwPath, {
        data,
    })
}

// 查询手机号
/**
 * 手机号查询
 */
export function fetchPhoneNum(params: InfoUsingGet1Params): API.Res<string> {
    return drpRequest.get('/phoneQuery/info', { params })
}

// 中台手机号查询
/**
 * 中台手机号查询
 */
export function fetchPhoneByOp(params: InfoQueryByOpUsingGetParams): API.Res<string> {
    return drpRequest.get('/phoneQuery/infoQueryByOp', { params })
}

// 中台手机号查询(根据name)
/**
 * 中台手机号查询
 */
export function queryPhoneByName(params: InfoQueryByOpUsingGet1Params): API.Res<string> {
    return drpRequest.get('/phoneQuery/queryPhoneByName', { params })
}

// 查询负责人（联系人）手机号
/**
 * 查询联系人手机号
 */
export function fetchContactPhone(params: QueryContactPhoneUsingGetParams): API.Res<string> {
    return drpRequest.get('/phoneQuery/queryContactPhone', { params })
}

// 主动维护手机号
/**
 * 主动维护自己的手机号
 */
export function updateSelfPhone(data: ChannelContactParam): API.Res<object> {
    return drpRequest.post('/user/updateSelfPhone', { data })
}

// 查询用户配置(注意接口服务端缓存)
export const queryUserConfig = params => {
    return securityRequest.get('/security/configUser/list', {
        params,
    })
}

// 添加用户配置
export const addUserConfig = data => {
    return securityRequest.post('/security/configUser/insert', {
        data,
    })
}

// 公司简要信息
/**
 * 公司简要信息
 */
export function simpleInfo(params: SimpleInfoUsingGetParams): API.Res<SimpleCompanyInfo> {
    return drpRequest.get('/company/simple/info', { params })
}

// 密/明文获取公司负责人信息
/**
 * 获取公司负责人信息
 */
export function getDirectorInfo(data: DirectorInfoParam): API.Res<DirectorInfoVo> {
    return drpRequest.post('/company/getDirectorInfo', { data })
}

// 获取erp token
// https://devops.aliyun.com/projex/req/JSTGYL-26147# 《优化: 脱敏url》
export function getPlatToken() {
    return companyRequest.post('/user/currentUserId')
}

// 查询用户的权限（库存编辑、查看成本价、成本价编辑）目前上架弹窗中使用
/**
 * 获取ERP部分权限
 */
export function queryUserPermission(): API.Res<object> {
    return companyRequest.get('/company/permission/getUserPermission')
}

// 获取简要用户信息
export const acquireSimpleUser = () => {
    return drpRequest.get('/user/acquireSimpleUser')
}

// 一键排序搜索项
/**
 * 获取搜索项
 */
export function getSearchItem(params: GetSearchItemUsingGetParams): API.Res<Record<string, object>> {
    return companyRequest.get('/searchItemUser/getSearchItem', { params })
}

// 获取分仓信息
export function acquireWmsInfo() {
    return companyRequest.get('/wms/acquireWmsInfo')
}

// 颁发供应链授权码
export const getAuthCode = () => companyRequest.get('/user/auth/code')

// 获取当前登录用户的手机号
export function getCurrentUserPhone() {
    return drpRequest.get('/user/getCurrentUserPhone')
}

// 解绑
/**
 * 解绑微信/钉钉
 */
export function unBindingUnionId(data: UnBindingParam): API.Res<object> {
    return companyRequest.post('/user/unBindingUnionId', { data })
}

// 查询商家配置
export const queryConfigListForCompany = params => {
    return securityRequest.get('/security/configUser/listForCompany', {
        params,
    })
}

// 更新商家配置
export const insertOrUpdateForCompany = data => {
    return securityRequest.post('/security/configUser/insertOrUpdateForCompany', {
        data,
    })
}

// 统一erp/gyl名称
/**
 * 统一商家名称
 */
export function unifyCompanyName(): API.Res<object> {
    return drpRequest.post('/company/unifyCompanyName')
}

// 是否主分仓 https://devops.aliyun.com/projex/req/JSTGYL-19247# 《奇门、三方仓商家实时跳转老版售后》
export const wmsHasOwnerWarehouse = () => {
    return towerAftersaleRequest.get('/partners/type')
}
// 获取当前用户是否主分仓
export const partnerCheckApi = () => {
    return companyRequest.get('/afterSale/warehouses/partnerCheck')
}

// 查询供应商联系方式
/**
 * 查询供应商联系方式
 */
export function querySupplierContactWay(params: QuerySupplierContactWayUsingGetParams): API.Res<ContactWayQueryVo> {
    return drpRequest.get('/phoneQuery/querySupplierContactWay', { params })
}

// 是否在epaas 标签中
/**
 * 查询用户是否存在标签
 */
export function isUserWithLabels(data: string[]): API.Res<UserWithLabelsVo[]> {
    return companyRequest.post('/user/config/isUserWithLabels', { data })
}

// 删除epaas 标签中的coid
/**
 * 删除用户标签
 */
export function deleteUserLabel(data: EditCompanyLabelParam): API.Res<object> {
    return companyRequest.post('/user/config/deleteUserLabel', { data })
}

// 查询用户配置
export const getUserConfigValue = (params = { configType: '' }) =>
    drpRequest.get('/userConfig/getConfigValue', {
        params,
    })

export const updateUserConfigValue = (
    data = {
        configType: '',
        configValue: false,
    },
) =>
    drpRequest.post('/userConfig/updateConfigValue', {
        data,
    })

/**
 * 是否线下交易限制的免费版商家
 */
export function offlineFreeVersionUsingGET(): API.Res<boolean> {
    return companyRequest.get('/companyContract/isFreeContract')
}

/**
 * 授权V2
 */
export function grantAuthV2UsingPOST(data: GrantAuthParam): API.Res<boolean> {
    return companyRequest.post('/open/auth/grantAuthV2', { data })
}

/**
 * 重新发送验证短信
 */
export function resendSmsAuthCodeUsingPOST(data: ResendSmsAuthCodeParam): API.Res<null> {
    return companyRequest.post('/open/auth/resendSmsAuthCode', { data })
}
